class GaiaDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("summary + *");

    this.details.classList.add("closed");

    if (this.content.getAttribute("tabindex") === null)
      this.content.setAttribute("tabindex", "0");

    this.summary.addEventListener("click", (e) => {
      this.click(e);
    });

    this.clickOffListener = this.clickOff.bind(this);
  }

  clickOff(e) {
    if (!this.details.open) return;
    // Ignore clicks on the summary itself (the toggle button)
    if (e.target === this.summary || this.summary.contains(e.target)) return;
    const megaMenu = this.details.querySelector(".mega-menu");
    if (megaMenu) {
      // If click is outside the .mega-menu, close
      if (!megaMenu.contains(e.target)) {
        this.close();
      }
    } else {
      // Default: close if click is outside the dropdown
      if (!this.contains(e.target)) {
        this.close();
      }
    }
  }

  click(e) {
    e.preventDefault();
    if (
      this.details.open ||
      this.details.classList.contains("opening") ||
      this.details.classList.contains("open")
    ) {
      this.close();
    } else {
      this.open();
    }
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      let ariaLabel = detailsElement.getAttribute("aria-label") || "";
      if (detailsElement.hasAttribute("open")) {
        ariaLabel = ariaLabel.replace("Open", "Close");
      } else {
        ariaLabel = ariaLabel.replace("Close", "Open");
      }
      detailsElement.setAttribute("aria-label", ariaLabel);
    }
  }

  open() {
    document.querySelectorAll("gaia-dropdown").forEach((dropdown) => {
      if (dropdown !== this && dropdown.details.open) {
        dropdown.details.classList.remove("open", "opening", "closing");
        dropdown.details.classList.add("closed");
        dropdown.details.removeAttribute("open");
        document.removeEventListener("click", dropdown.clickOffListener);
      }
    });

    this.details.classList.remove("closed");
    this.details.classList.remove("closing");
    this.details.classList.add("opening");
    this.details.setAttribute("open", true);

    if (!this.closest("details"))
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    setTimeout(() => {
      this.details.classList.remove("opening");
      this.details.classList.add("open");
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    }, 300);

    this.updateAriaLabel();
    // resizeAllMasonryItems(".masonry-grid");
    document.addEventListener("click", this.clickOffListener);
  }

  close() {
    this.details.classList.remove("open");
    this.details.classList.remove("opening");
    this.details.classList.add("closing");
    if (!this.closest("details"))
      document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      this.details.removeAttribute("open");
      this.details.classList.remove("closing");
      this.details.classList.add("closed");
    }, 300);
    document.removeEventListener("click", this.clickOffListener);
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define("gaia-dropdown", GaiaDropdown);

class GaiaSelect extends GaiaDropdown {
  constructor() {
    super();

    this.selectedOption = this.querySelector(".selected-option");
    this.fieldset = this.querySelector("fieldset");
    this.options = this.querySelector(".options");
    this.summary = this.querySelector("summary");
    //Looking for  <gaia-select data-subscription-widget="true"></gaia-select>
    this.isSubscriptionWidget = this.hasAttribute("data-subscription-widget");

    // this.options.removeAttribute("tabindex");

    this.fieldset.addEventListener("change", (event) => {
      // Workaround for subscription widgets, as value is needed for adding correct subscription
      if (this.isSubscriptionWidget) {
        this.selectedOption.innerText =
          this.querySelector("input:checked").getAttribute("radio-name");
      } else {
        this.selectedOption.innerText =
          this.querySelector("input:checked").value;
      }
      console.log(event.detail);
      // this.summary.click();
    });

    // For accessibility, ensure tab is taking you to the next option
    this.options.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "TAB") {
        event.preventDefault();
        this.focusNextInput();
      }
    });
  }

  open() {
    this.details.classList.remove("closed");
    this.details.classList.remove("closing");
    this.details.classList.add("opening");
    this.details.setAttribute("open", true);

    document.addEventListener("click", this.clickOffListener);
    this.querySelector(".options input").focus();
  }

  focusNextInput() {
    // Get correct next option to focus
    const focusableElements = Array.from(
      this.querySelectorAll(".options input:not([type=hidden]):enabled"),
    );
    const currentFocusedElement = document.activeElement;
    const currentIndex = focusableElements.indexOf(currentFocusedElement);
    if (currentIndex > -1 && currentIndex < focusableElements.length - 1) {
      focusableElements[currentIndex + 1].focus();
    } else if (currentIndex === focusableElements.length - 1) {
      // Move to the next focusable element in the document once you reach the end of select options
      const allFocusableElements = Array.from(
        document.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
        ),
      );
      const nextIndex = allFocusableElements.indexOf(currentFocusedElement) + 1;
      if (nextIndex < allFocusableElements.length) {
        allFocusableElements[nextIndex].focus();
      }
    }
  }
}

customElements.define("gaia-select", GaiaSelect);
